<template>
  <div class="form place-form">
    <div class="field">
      <label for="name" class="label">Nome *</label>
      <div class="control">
        <input
          type="text"
          class="input"
          id="name"
          v-model="fData.name"
          :disabled="disabledFields.name"
        >
      </div>
    </div>
    <div class="field">
      <label for="shortdesc" class="label">Descrição Curta *</label>
      <div class="control">
        <textarea
          v-model="fData.shortDescription"
          id="shortdesc"
          maxlength="400"
          rows="10"
          class="textarea"
          :disabled="disabledFields.shortDescription"
        ></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="600"
            :data-string="fData.shortDescription"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="longdesc" class="label">Descrição Longa *</label>
      <div class="control">
        <textarea
          v-model="fData.longDescription"
          id="longdesc"
          maxlength="800"
          rows="10"
          class="textarea"
          :disabled="disabledFields.longDescription"
        ></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="1000"
            :data-string="fData.longDescription"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="informations" class="label">Informações *</label>
      <div class="control">
        <textarea
          v-model="fData.informations"
          id="informations"
          maxlength="800"
          rows="10"
          class="textarea"
          :disabled="disabledFields.informations"
        ></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="1000"
            :data-string="fData.informations"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="operation" class="label">Operações</label>
      <div class="control">
        <textarea v-model="fData.operation" id="operation" maxlength="400" rows="10" class="textarea"></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="600"
            :data-string="fData.operation"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field has-text-centered">
      <button
        class="button is-primary is-large"
        @click="onSubmit(fData)"
        :class="{ 'is-loading': isLoading }"
        :disabled="isDisabled || $v.fData.$invalid"
      >
        {{ButtonLabel || "Cadastrar"}}
      </button>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import FormMixin from './FormMixin'
import CharCount from '../CharCount'

export default {
  name: 'PlaceTranslateForm',
  mixins: [FormMixin],
  components: { CharCount },
  data () {
    return {
      isSearchingLocation: false,
      fData: {
        name: '',
        shortDescription: '',
        longDescription: '',
        informations: '',
        operation: ''
      }
    }
  },
  validations: {
    fData: {
      name: {
        required
      },
      shortDescription: {
        required,
        maxLength: maxLength(600)
      },
      longDescription: {
        required,
        maxLength: maxLength(1000)
      },
      informations: {
        required,
        maxLength: maxLength(1000)
      },
      operation: {
        maxLength: maxLength(600)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/PlaceTranslateForm.vue